module.exports = __webpack_public_path__ + "img/line.938db816.svg";